import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "rnaMutClassText" })
export class RNAMutStatusClassPipe implements PipeTransform {
  /**
   * Determines the CSS color class for an RNA/mutation status value.
   * @param value RNA/mutation status, or null/undefined if unknown
   * @return CSS color class name
   */
  transform(value: boolean | null | undefined): string {
    if (value === true) return "green";
    if (value === false) return "red";
    return "gray";
  }
}

@Pipe({ name: "rnaMutStatusText" })
export class RNAMutStatusTextPipe implements PipeTransform {
  /**
   * Determines the translation key for an RNA/mutation status value.
   * @param value RNA/mutation status, or null/undefined if unknown
   * @return Translation key describing the status
   */
  transform(value: boolean | null | undefined): string {
    if (value === true) return "uploadData.rnaMutation.uploaded";
    if (value === false) return "uploadData.rnaMutation.missing";
    return "common.notFound";
  }
}
